<div class="page">
  <ng-content></ng-content>

  <div
    *ngIf="showDealerInformation && modelAndDealerService.selectedDealer"
    class="container"
  >
    <div class="row mt-5">
      <div class="col-12">
        <h2>
          {{
            "page.dealerInformationTitle"
              | translate
                : { dealerName: modelAndDealerService.selectedDealer.name }
          }}
        </h2>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <vw-dealer-information
          [dealer]="modelAndDealerService.selectedDealer"
        ></vw-dealer-information>
      </div>
    </div>
  </div>

  <vw-footer *ngIf="footerSection" [footerSection]="footerSection"></vw-footer>
</div>
